/**
 * Created by Mikhail Menshenin on 15.08.2024
 */

const CoinSlotMachineActions = {
    attack: function (cb) {
        cb = cb || function () { };
        const village = Village.CreateEnemy(cleverapps.villagePlayers.getAttackPlayer());
        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "VillageAttackScene",
            control: ["slotMachine", "button"],
            action: function (f) {
                CoinKingdom.OpenVillageAction(bundles.main.jsons.villageattackscene_prefab_json, village, f);
                cb();
            }
        });
    },

    raid: function (cb) {
        cb = cb || function () { };
        const village = Village.CreateEnemy(cleverapps.villagePlayers.getRaidPlayer());
        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "VillageRaidScene",
            control: ["slotMachine", "button"],
            action: function (f) {
                CoinKingdom.OpenVillageAction(bundles.main.jsons.villageraidscene_prefab_json, village, f);
                cleverapps.villagePlayers.resetRaidPlayer();
                cb();
            }
        });
    }
};
